<template>
  <div class="autable-wrap">
    <div class="header-wrap">
      <el-select style="width: 240px" v-model="filterData.pkg" placeholder="选择产品" filterable>
        <el-option label="全部产品" :value="-1"> </el-option>
        <el-option
          v-for="item of appList"
          :key="item.package_name"
          :label="item.app_name + '（' + item.package_name + '）'"
          :value="item.package_name"
        >
        </el-option>
      </el-select>
      <el-select
        style="width: 240px; margin-left: 24px"
        class="multiple-select"
        v-model="filterData.advertiserId"
        placeholder="全部投放账户"
        multiple
        collapse-tags
        filterable
      >
        <el-option
          v-for="item of advertiserIdList"
          :key="item.advertiserId"
          :label="item.company + ' (' + item.advertiserName + ')'"
          :value="item.advertiserId"
        >
        </el-option>
      </el-select>
      <el-date-picker
        class="data-range"
        v-model="filterData.time"
        type="daterange"
        :picker-options="pickerOptions"
        range-separator="→"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 240px; margin-left: 24px"
        value-format="yyyyMMdd"
        :clearable="false"
      >
      </el-date-picker>
      <el-button class="submit-btn" style="margin-left: auto" @click="resetForm">重置</el-button>
      <el-button class="submit-btn" @click="searchData" type="primary">查询</el-button>
    </div>
    <div class="charts-wrap">
      <Chart :dataList="chartsData_sex" title="性别分布" style="margin-right: 16px"></Chart>
      <Chart :dataList="chartsData_age" title="年龄分布"></Chart>
    </div>
    <div class="table-wrap">
      <div class="table-header">
        <el-select
          style="width: 160px"
          v-model="filterData.audienceType"
          @change="changeaudienceType"
        >
          <el-option label="省份" value="province"> </el-option>
          <el-option label="城市" value="city"> </el-option>
          <el-option label="性别" value="gender"> </el-option>
          <el-option label="年龄" value="age"> </el-option>
        </el-select>
      </div>
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column
          v-for="item of colData"
          :key="item.value"
          :prop="item.value"
          :label="item.label"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getCommonProductList } from "@/api/api.js";
import { getAdvertiserInfo, queryAudience } from "@/api/report.js";
import Chart from "./chart.vue";
export default {
  name: "audienceAnalysis",
  components: {
    Chart,
  },
  data() {
    return {
      appList: [],
      advertiserIdList: [],
      chartsData_sex: [],
      chartsData_age: [],
      colData: [],
      tableData: [],
      filterData: {
        pkg: -1,
        advertiserId: [],
        time: [
          moment().subtract(7, "days").format("YYYYMMDD"),
          moment().subtract(1, "days").format("YYYYMMDD"),
        ],
        audienceType: "province",
      },
      loading: true,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              picker.$emit("pick", [
                moment().subtract(7, "days").format("YYYYMMDD"),
                moment().subtract(1, "days").format("YYYYMMDD"),
              ]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              picker.$emit("pick", [
                moment().subtract(30, "days").format("YYYYMMDD"),
                moment().subtract(1, "days").format("YYYYMMDD"),
              ]);
            },
          },
          {
            text: "最近二个月",
            onClick(picker) {
              picker.$emit("pick", [
                moment().subtract(60, "days").format("YYYYMMDD"),
                moment().subtract(1, "days").format("YYYYMMDD"),
              ]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.initSelectOptions();
    this.searchData();
  },
  methods: {
    initSelectOptions() {
      getCommonProductList({
        platType: 1,
      }).then((res) => {
        if (res.code === "0000") {
          this.appList = res.data;
        }
      });
      getAdvertiserInfo().then((res) => {
        if (res.code === "0000") {
          this.advertiserIdList = res.advertiseInfos;
        }
      });
    },
    formatData() {
      let parmas = {
        startTime: this.filterData.time[0],
        endTime: this.filterData.time[1],
      };
      for (let key in this.filterData) {
        let checkData = this.filterData[key];
        if (checkData === "" || checkData === -1 || key === "time") {
          continue;
        }
        if (Array.isArray(checkData)) {
          checkData.length > 0 && (parmas[key] = checkData.join());
        } else {
          parmas[key] = checkData;
        }
      }
      return parmas;
    },
    searchData() {
      this.searchTable();
      this.searchCharts();
    },
    resetForm() {
      this.filterData.pkg = -1;
      this.filterData.advertiserId = [];
      this.filterData.time = [
        moment().subtract(7, "days").format("YYYYMMDD"),
        moment().subtract(1, "days").format("YYYYMMDD"),
      ];
      this.filterData.audienceType = "province";
    },
    changeaudienceType() {
      this.searchTable();
    },
    //设置列字段
    setTableCols() {
      let colData = [
        { label: "消耗", value: "cost" },
        { label: "展示", value: "show_cnt" },
        { label: "点击", value: "click_cnt" },
        { label: "点击率", value: "click_rate" },
        { label: "转化", value: "convert_cnt" },
        { label: "转化率", value: "convert_rate" },
      ];
      switch (this.filterData.audienceType) {
        case "province":
          colData.unshift({ label: "省份", value: "province_name" });
          break;
        case "city":
          colData.unshift({ label: "城市", value: "city_name" });
          break;
        case "gender":
          colData.unshift({ label: "性别", value: "gender_name" });
          break;
        case "age":
          colData.unshift({ label: "年龄", value: "age_name" });
          break;
        default:
      }
      this.colData = colData;
    },
    searchTable() {
      let parmas = this.formatData();
      this.loading = true;
      queryAudience(parmas).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          console.log(res.audienceDataPacks);
          this.tableData = res.audienceDataPacks.map((item) => {
            item.cost = item.cost.toFixed(2);
            item.click_rate = (item.click_rate * 100).toFixed(2) + "%";
            item.convert_rate = (item.convert_rate * 100).toFixed(2) + "%";
            return item;
          });
        }
      });
      this.setTableCols();
    },
    searchCharts() {
      let parmas = this.formatData();
      Promise.all([
        queryAudience(Object.assign({}, parmas, { audienceType: "gender" })),
        queryAudience(Object.assign({}, parmas, { audienceType: "age" })),
      ]).then(([sexData, ageData]) => {
        this.chartsData_sex = (sexData.audienceDataPacks || []).map((item) => {
          item.label = item.gender_name;
          return item;
        });
        this.chartsData_age = (ageData.audienceDataPacks || []).map((item) => {
          item.label = item.age_name;
          return item;
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.autable-wrap {
  padding: 16px;
  box-sizing: border-box;
  height: 100%;
  overflow: auto;
  .header-wrap {
    display: flex;
    align-items: center;
    padding: 15px 24px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    .multiple-select {
      /deep/ .el-tag.el-tag--info:first-child {
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .data-range {
      position: relative;
      /deep/.el-range__icon {
        position: absolute;
        right: 6px;
        top: 0px;
      }
      /deep/.el-range-separator {
        line-height: 24px;
        color: rgba(0, 0, 0, 0.25);
      }
    }
    .submit-btn {
      padding: 0 20px;
    }
  }
  .charts-wrap {
    display: flex;
    margin-top: 16px;
  }
  .table-wrap {
    margin-top: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 24px;
    .table-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;
    }
  }
}
</style>
